// Structured résumé content for Rakesh Mhasawade.

export const profile = {
  name: 'Rakesh Mhasawade',
  location: 'Pune, India',
  email: 'rakesh.mhasawade@hotmail.com',
  linkedin: 'https://www.linkedin.com/in/rakesh-mhasawade-268b1816/',
  github: 'https://github.com/rakesh-m',
};

export const summaryLine =
  'C++ (8+ years) | Javascript (3 years) | GitHub (5+ years) | German (CFER B1)';

export const strengths = [
  'Varied experience in multiple domains spread over more than 15 years.',
  'Experience on all phases of software development.',
  '8+ years of C++ development experience including with C++ 11.',
  '3+ years of experience working with clients for requirements gathering, technical consulting, delivery planning.',
  'Excellent analytical skills and good technical skills.',
  'Clear and unambiguous communication with attention to detail.',
];

export const currentProfile = {
  title: 'Designer',
  company: 'KPIT Technologies',
  when: 'since July 2023',
  project: 'Charging for Electric Vehicles for a major OEM',
  projectDesc: "System requirements and change requests' management.",
  tools: 'DOORS, JIRA, GitHub',
  tasks: [
    {
      lead: 'Technical discussions',
      text: 'Conduct tech discussions with client and internal stakeholders to discuss and finalise system change requests (CRs).',
    },
    {
      lead: 'Concept presentation',
      text: 'Present CR to internal stakeholders, note open points, and track them to closure.',
    },
    {
      lead: 'Planning',
      text: 'Plan CR changes considering delivery timelines and dependencies and track them to closure.',
    },
    {
      lead: 'System Requirements (SYRs)',
      text: 'Create, update, maintain and clean-up SYRs for new CRs and error tickets.',
    },
  ],
};

export const relevantExperience = {
  title: 'Senior Tools Programmer',
  company: 'Ubisoft',
  when: 'from September 2019 to July 2023',
  project: 'Video game: Riders Republic',
  projectDesc:
    'Handle game development tools issues and data reports tracking various game and development metrics.',
  tools: 'JavaScript, C#, C++, Visual Studio, Perforce, GitHub',
  tasks: [
    {
      lead: 'Metrics tracker reports:',
      text: 'Feature additions/updates/bugfixing for metrics tracker reports with internal report creation framework using web development technologies (HTML, JavaScript, CSS).',
    },
    {
      lead: 'Development and bug fixes',
      text: 'For game development tools using C# and C++.',
    },
  ],
};

export const pastWork = [
  {
    organization: 'Tata Consultancy Services',
    duration: 'Apr 2015 - Sep 2019',
    designation: 'Assistant Consultant',
    summary: 'Automotive SW design and dev in C++',
  },
  {
    organization: 'Amdocs DVCI',
    duration: 'Mar 2014 - Apr 2015',
    designation: 'Software Engineer (Advanced)',
    summary: 'Telecom SW dev with C, C++',
  },
  {
    organization: 'Atos India',
    duration: 'Jun 2010 - Mar 2014',
    designation: 'Senior Software Engineer',
    summary: 'Avionics SW dev with C.',
  },
];

export const education = [
  {
    degree: 'B.E. (Computer Science)',
    institution: 'Savitribai Phule Pune University',
    year: '2010',
    score: 'Higher second class',
  },
  {
    degree: "Diplôme d'Études en Langue Française, level B2",
    institution: 'French Ministry of Education',
    year: '2021',
    score: '77.5 / 100',
  },
  {
    degree: 'Goethe-Zertifikat B1',
    institution: 'Goethe Institut',
    year: '2025',
    score: '326 / 400',
  },
];
